export default "__VITE_ASSET__C$yaaqtm__"